import React from 'react';
import clsx from 'clsx';

interface LoadingOverlayProps {
  isVisible: boolean;
  status?: string;
  className?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  status = 'Loading...',
  className
}) => {
  if (!isVisible) return null;

  return (
    <div
      className={clsx(
        'fixed inset-0 z-[10001] flex items-center justify-center transition-opacity duration-300',
        'bg-black/40 backdrop-blur-sm',
        className
      )}
      style={{ pointerEvents: 'auto' }}
    >
      <div className="bg-white rounded-xl shadow-2xl p-8 flex flex-col items-center gap-4 min-w-[280px] max-w-md mx-4">
        {/* Animated Spinner */}
        <svg
          className="w-16 h-16 animate-spin text-unity-blue"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="3"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>

        {/* Status Message */}
        <div className="text-center">
          <p className="text-gray-700 font-medium text-base">
            {status}
          </p>
          <p className="text-gray-500 text-sm mt-1">
            Please wait...
          </p>
        </div>
      </div>
    </div>
  );
};

export { LoadingOverlay };
